import { makeAutoObservable } from 'mobx';

import { nextIdFactory } from 'app/libs/next-id';

import {
  INotifications,
  TExistingNotification,
  TNewNotification,
  TNotification,
  TRemovedNotification,
} from '../../core/notifications';

const nextId = nextIdFactory();

type AddErrorBehaviour = 'add_msg' | 'replace_msg';

type NotificationsStoreParams = {
  /**
   * @param behaviour specify the behavior to apply when adding a new message
   * - add_error - added new message to another (display multiply messages like queue)
   * - replace_error - replaced previous messages with another (display only one message)
   */
  behaviour?: AddErrorBehaviour;
};

export class NotificationsStore implements INotifications {
  private _messages: TNotification[] = [];
  private behaviour: AddErrorBehaviour = 'add_msg';

  get messages() {
    return this._messages;
  }

  get lastMessage(): TNotification {
    return this._messages[this._messages.length];
  }

  constructor({ behaviour = 'add_msg' }: NotificationsStoreParams = {}) {
    this.behaviour = behaviour;

    makeAutoObservable(this);
  }
  hasMessage(notification: TExistingNotification): boolean {
    return this._messages.some((msg) => msg.id === notification.id);
  }

  addMessage(notification: TNewNotification): void {
    switch (this.behaviour) {
      case 'replace_msg':
        this._messages = [{ ...notification, id: nextId() }];
        break;

      case 'add_msg':
      default:
        this._messages.push({ ...notification, id: nextId() });
        break;
    }
  }
  removeMessage(notification: TRemovedNotification): void {
    this._messages = this._messages.filter((msg) => msg.id !== notification.id);
  }
  clearAll(): void {
    this._messages = [];
  }
}
